import {
  admin,
  bank,
  gpt3,
  great,
  luxe,
  mennsom,
  mytube,
  akugbe,
  synclexx,
  scaza,
} from "../assets";

export const portfolios = [
  {
    id: "01",
    imgUrl: synclexx,
    category: "E-commerce",
    title: "Synclexs Website",
    description:
      "Snyclexs is a platform that connects legal professionals with cutting-edge technology to streamline operations. It prioritizes user experience, robust transaction management, secure payment processing, and efficient contract handling.",
    technologies: [
      "React",
      "TailwindCss",
      "Redux",
      "Redux Toolkit",
      "Rest API",
      "Typescript",
    ],
    siteUrl: "https://lagosnbarp.org/",
  },
  {
    id: "02",
    imgUrl: scaza,
    category: "Fintech",
    title: "Scaza payment plattform",
    description:
      "Scaza is a fintech platform designed to facilitate secure and seamless digital payments. It provides users with an intuitive interface for managing transactions, processing payments, and accessing financial services while ensuring reliability, security, and a smooth user experience.",
    technologies: [
      "React",
      "TailwindCss",
      "Redux",
      "Redux Toolkit",
      "Rest API",
      "Typescript",
    ],
    siteUrl: "https://app.scaza.org/",
  },
  {
    id: "03",
    imgUrl: mennsom,
    category: "Web Development",
    title: "Mennsom Website",
    description:
      "A platform for an energy company where they can showcase their products and services. The platform also provides a space for clients to contact the company for their services.",
    technologies: ["React", "Tailwind css", "Node.js"],
    siteUrl: "https://mennsom.com/",
  },
  {
    id: "04",
    imgUrl: akugbe,
    category: "E-commerce",
    title: "Akugbe geo",
    description: "",
    technologies: ["React", "TailwindCss", "Typescript"],
    siteUrl: "https://akugbegeo.com/",
  },

  {
    id: "05",
    imgUrl: luxe,
    category: "Web Development",
    title: "Luxe Dental Website",
    description:
      "A platform for a dental clinic on which the clinic can showcase the services they provide and clients can book appointments online. Also provides a blog space where the dentist can post dental hygene tips",
    technologies: ["Html5", "CSS3", "Node.js", "FirebaseDB"],
    siteUrl: "https://luxedental.com.ng/",
  },
  {
    id: "07",
    imgUrl: great,
    category: "Web Development",
    title: "Great Oak Website",
    description:
      "A website for a metal fabrication company where they can showcase recently concluded projects and get connected to prospective clients.",
    technologies: ["Html5", "CSS3", "PHP", "SQL"],
    siteUrl: "https://greatoak.com.ng/",
  },
  // {
  //   id: "08",
  //   imgUrl: osi,
  //   category: "Web Development",
  //   title: "Cabbi Food Website",
  //   description:
  //     "A  website for a food produce company which helps them showcase their products online and allow clients cntact them to make orders.",
  //   technologies: ["Html5", "CSS", "PHP"],
  //   siteUrl: "https://cabbifoods.osimheventures.com/",
  // },
  {
    id: "09",
    imgUrl: admin,
    category: "Web Development",
    title: "Admin Panel",
    description:
      "An Admin Panel project. Created with React Js, Material UI, Nivo Charts and Full Calendar",
    technologies: ["React", "Material UI", "Nivo chart"],
    siteUrl: "https://capable-shortbread-5ab7f9.netlify.app/",
  },
  {
    id: "10",
    imgUrl: mytube,
    category: "Web Development",
    title: "Mytube - A youtube clone",
    description:
      "A youtube clone app that fetches data from Rest API youtube API. This application allows users search for videos, select the videos and watch them. It also allows users search for channels of creators they wish to see",
    technologies: ["React", "Material-UI", "Rest API"],
    siteUrl: "https://magnificent-fudge-aa19d1.netlify.app/",
  },
  {
    id: "11",
    imgUrl: bank,
    category: "Web Development",
    title: "Bank Landing Page",
    description:
      "A Landing page excercise for a Bank. Created with React Js Tailwind Css and ViteJs.",
    technologies: ["React", "Material UI"],
    siteUrl: "https://soft-mermaid-ac7d10.netlify.app/",
  },
  {
    id: "12",
    imgUrl: gpt3,
    category: "Web Development",
    title: "Landing Page",
    description:
      "A Landing page excercise for Gpt-3 AI bots. Created with React Js and Vanilla Css.",
    technologies: ["React", "CSS#"],
    siteUrl: "https://guileless-speculoos-93ba8e.netlify.app/",
  },
];
